export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50];
export const DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE_OPTIONS[0];
export const DEFAULT_PAGE_INDEX = 0;
